module.exports = __webpack_public_path__ + "static/media/blog1.c9b1c2a2.webp";